import { DefaultTheme } from 'styled-components'

export const BLUE: DefaultTheme = {
  primary: '#2550E5',
  light: '#EAEEFD',
}

export const TURQUOISE = {
  primary: '#1ABB89',
  light: '#A5F3DA',
}

export const GINGER = {
  primary: '#FF4900',
  light: '#FFD073',
}

export const GREEN = {
  primary: '#20573D',
  light: '#A9D2C1',
}

export const NAVY = {
  primary: '#0F2F6F',
  light: '#A3BCE1',
}

export const OCEANIC = {
  primary: '#2E5BFF',
  light: '#1ABC9C',
}

export const LAVENDER = {
  primary: '#8280FF',
  light: '#E8E7FF',
}

export const SAPPHIRE = {
  primary: '#3B75EF',
  light: '#6B9CFF',
}
